import api, { request } from '../../../api';

import { IAdminSeasonAwardsStore } from './store';

import { groupBy } from '../../../contrib/utils';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';

export type TGetSeasonAwardsAction = (
  seasonId: number,
  force?: boolean
) => { adminSeasonAwards?: IAdminSeasonAwardsStore; errors?: IErrorsStore };

export interface IAdminSeasonAwardsActions extends IActionGroup {
  get: TGetSeasonAwardsAction;
}

const actions: IActionGroup = {
  get: async (state: IStore, seasonId: number) => {
    if (state.adminSeasonAwards[seasonId]) {
      return {
        adminSeasonAwards: state.adminSeasonAwards
      };
    }

    const response = await request.get(api.seasonAwards('staff', seasonId));

    if (response.error) {
      return { errors: { adminSeasonAwards: { msg: 'Error retrieving the Season Awards' } } };
    }

    return {
      adminSeasonAwards: {
        [seasonId]: groupBy(response, 'userId')
      }
    };
  }
};

export default actions;
